<fin-block-offer-tile
  (linkClicked)="emitClick($event)"
  (amContinueModalClick)="openAmContinueModal($event)"
  class="fill block flex slim"
  [blockOffer$]="offer | finToObservable"
  [showRoundTripPrice$]="showRoundTripPrices$"
  (calendarClicked)="emitCalendarClick($event)"
  [showPriceCalendarButton]="true"
>
</fin-block-offer-tile>
<fin-am-destination-continue-modal
  [open]="isAmContinueModalOpen"
  (closeModal)="closeAmContinueModal()"
  [bookUrl]="flightHotelUrl"
></fin-am-destination-continue-modal>
